
import { useContext, useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import { FaShoppingCart } from "react-icons/fa"
import { CarritoSidebar } from '../components';
import { CarritoContext } from '../context/CarritoContext';

import { useTranslation } from 'react-i18next'
import { useMobileDetection } from '../hook/useMobileDetection'


export const NavBar = () => {
  const { abrirCarrito, carrito } = useContext(CarritoContext)
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const isMobile = useMobileDetection()
  

  const logo = "/image/logos/LOGO1_MT1.png"


  const [contadorDelCarrito, setContadorDelCarrito] = useState(0)
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [customNavbar, setCustomNavbar] = useState(true);

  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  useEffect(() => {
    const currentPath = location.pathname.split("/")[1]
    setCustomNavbar(currentPath==="inicio" || currentPath==="nosotros" || currentPath==="experiencias" || currentPath==="contacto")

  },[location.pathname])


  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  const accionAbrirCarrito = () => {
    abrirCarrito()
    closeNav()
  }

  const numeroProductosDistintos = () => {
    setContadorDelCarrito(carrito.length)
  }

  useEffect(() => {
    numeroProductosDistintos()
    // eslint-disable-next-line
  }, [carrito])


  return (
    <nav className={`navbar  navbar-dark navbar-expand-md bg-primario ${!scrollPosition && customNavbar && !isMobile? "navbar-transparent" : ""} `} >
      <div className="container">
        <Link className="navbar-brand col-4 m-1" to="/inicio">
          <img height={60} src={logo} alt="Logo Altos de Azpitia" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded={isNavOpen ? 'true' : 'false'}
          aria-label="Toggle navigation"
          onClick={toggleNav}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`col-7 justify-content-end collapse navbar-collapse ${isNavOpen ? 'show' : 'close'
            }`}
          id="navbarNavDropdown"
        >
          <ul className="navbar-nav">
            <NavLink
              className={({ isActive }) => `nav-link me-2 w-auto link-deco ${isActive ? 'active' : ''}`}
              to="/inicio"
              onClick={closeNav}
            >
              {t('nav_inicio')}
            </NavLink>
            <NavLink className="nav-link me-2 link-deco" to="/nosotros" onClick={closeNav}>
              {t('nav_nosotros')}
            </NavLink>
            <NavLink className="nav-link me-2 link-deco" to="/experiencias" onClick={closeNav}>
              {t('nav_experiencias')}
            </NavLink>
            <NavLink className="nav-link me-2 link-deco" to="/tienda" onClick={closeNav}>
              {t('nav_tienda')}
            </NavLink>
            <NavLink className="nav-link me-2 link-deco" to="/galeria" onClick={closeNav}>
              {t('nav_galeria')}
            </NavLink>
            <NavLink className="nav-link link-deco" to="/contacto" onClick={closeNav}>
              {t('nav_contacto')}
            </NavLink>
            {i18n.resolvedLanguage === "es" && <NavLink id="cart-icono" className="nav-link" onClick={accionAbrirCarrito}>
              <FaShoppingCart fontSize={25} />
              {contadorDelCarrito > 0 && <div className="contador-cart">
                <div>{contadorDelCarrito}</div>
              </div>}
            </NavLink>}
          </ul>
        </div>
      </div>
      <CarritoSidebar />
    </nav>
  );
};
